// @ts-nocheck
import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Slider } from 'primereact/slider';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"

export const ModelSetOption = (props) => {
    const [layer, setLayer] = useState({});
    const [optionOpen, setOptionOpen] = useState(false);
    const [overlay, setOverlay] = useState(null);
    const [modelDrawModeList, setModelDrawModeList] = useState([]);
    const [drawMode, setDrawMode] = useState(0);
    const [modeScale, setModeScale] = useState(1);

    useEffect(() => {
        setLayer(props.layer)
        if (props.layer.MODE) {
            setModelDrawModeList([
                { value: 0, label: "原貼圖" },
                { value: 1, label: "依樓層分層" },
                { value: 2, label: "依高度分層" },
                { value: 3, label: "純色" },
            ]);
        }
        else {
            setModelDrawModeList([
                { value: 0, label: "純色" },
                { value: 1, label: "依樓層分層" },
                { value: 2, label: "依高度分層" },
            ])
        }
        if (props.layer.layerSetting) {
            setOptionOpen(props.layer.layerSetting.optionOpen);
            setOverlay(props.layer.layerSetting.overlay);
            setDrawMode(props.layer.layerSetting.drawMode);
            setModeScale(props.layer.layerSetting.modeScale)
        }
        else {
            if (props.layer.MODE) {
                props.layer.layerObject.setDrawMode(1, 3);
                setDrawMode(0);
            }
            else {
                props.layer.layerObject.setDrawMode(0, 0);
                setDrawMode(1);
            }
        }
    }, [props.layer])

    useEffect(() => {
        let item = props.layer;
        item.layerSetting = {
            optionOpen: optionOpen,
            overlay: overlay,
            drawMode: drawMode,
            modeScale: modeScale
        };
        props.layerUpdate(item, props.index);
    }, [optionOpen, overlay, drawMode, modeScale])

    const setOverlayCover = (e) => {
        if (e.value) {
            layer.layerObject.setOverlayName(e.value.TITLE);
            window.main.OView.updateScreen();
            setOverlay(e.value);
        }
        else {
            layer.layerObject.setOverlayName(null);
            window.main.OView.updateScreen();
            setOverlay(null);
        }
    }

    const setModelDrawMode = (e) => {
        let Mode = e.value;
        if (props.layer.MODE) {
            if (Mode === 0) {
                layer.layerObject.setDrawMode(1, 3);
            } else if (Mode === 1) {
                layer.layerObject.setFloorModeScale(1);
                layer.layerObject.setDrawMode(1, 0);
            } else if (Mode === 2) {
                layer.layerObject.setFloorModeScale(modeScale);
                layer.layerObject.setDrawMode(1, 1);
            } else if (Mode === 3) {
                layer.layerObject.setDrawMode(1, 2);
            }
        }
        else {
            if (Mode === 0) {
                layer.layerObject.setDrawMode(0, 2);
            } else if (Mode === 1) {
                layer.layerObject.setFloorModeScale(1);
                layer.layerObject.setDrawMode(0, 0);
            } else if (Mode === 2) {
                layer.layerObject.setFloorModeScale(modeScale);
                layer.layerObject.setDrawMode(0, 1);
            }
        }
        setDrawMode(e.value);
    }

    const setModeScaleValue = (value) => {
        layer.layerObject.setFloorModeScale(value);
        setModeScale(value);
    }

    const OptionCard = () => {
        return (
            <Card style={{ marginTop: "1rem" }}>
                <div className="field grid">
                    <label htmlFor="coverDropdown" class="col-12 mb-4 md:col-4 md:mb-0">影像披覆：</label>
                    <div className="col-12 md:col-8">
                        <Dropdown className="inputfield w-full" inputId="coverDropdown" value={overlay} options={props.selected2Dlayer} onChange={(e) => setOverlayCover(e)} optionLabel="TITLE" showClear placeholder="Select a Overlay." />
                    </div>
                </div>
                <Divider />
                <div className="field grid">
                    <label htmlFor="drawModeDropdown" class="col-12 mb-4 md:col-4 md:mb-0">繪製模式：</label>
                    <div className="col-12 md:col-8">
                        <Dropdown className="inputfield w-full" inputId="drawModeDropdown" value={drawMode} options={modelDrawModeList} onChange={(e) => setModelDrawMode(e)} optionLabel="label" placeholder="Select Model." />
                    </div>
                </div>
                {
                    drawMode === 2 ?
                        <div>
                            <div className='slider-description'>繪製比例： {modeScale} </div>
                            <Slider id="ModeScale" value={modeScale} onChange={(e) => setModeScaleValue(e.value)} min={1} max={100} />
                        </div> : null
                }
            </Card>
        )
    }
    const layerGoto = () => {
        layer.layerObject.goto();
    }

    return (
        <div>
            <div className="layer-item">
                <div className="layer-detail">
                    <div className="layer-name">{layer.TITLE}</div>
                </div>
                <div className="layer-action">
                    <Button icon="pi pi-cog" className="p-button-rounded p-button-info" onClick={() => { setOptionOpen(!optionOpen) }} />
                    <Button icon="pi pi-map-marker" className="p-button-rounded p-button-info" onClick={() => { layerGoto() }} />
                    <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => { props.layerRemove(props.index) }} />
                </div>
            </div>
            {
                optionOpen ? OptionCard() : null
            }
            <Divider />
        </div>
    )
}